import React from "react";
import { Grid, Typography, Box, Divider } from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";

import translate from "../i18n/Translator";
import Surface from "../components/Surface";
import { CurrencyDebtorResponse } from "../model/Dashboard";
import CurrencyFormat from "../components/CurrencyFormat";

interface DebtorsDashboardProps {
    debtor: CurrencyDebtorResponse;
}

export default function DebtorsDashboard(props: DebtorsDashboardProps) {

    return (
        <Surface title={translate("dashboard.debtors.title", { "number": props.debtor.items.length })} subtitle={translate(`currencies.${props.debtor.currency}`)} icon={<BusinessIcon />}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {props.debtor.items.map((item, index) => (
                        <Grid container key={item.customer.id}>
                            <Grid item xs={12} md={7}>
                                <Typography variant="caption" component="h6">
                                    {item.customer.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography variant="body1" component="h6" align="right">
                                    <CurrencyFormat amount={item.balance} currency={props.debtor.currency} />
                                </Typography>
                            </Grid>
                            {index < (props.debtor.items.length - 1) && (
                                <Grid item xs={12}>
                                    <Box py={1}>
                                        <Divider />
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Surface>
    );

}